import { Container, Row, Col } from "react-bootstrap";
import { Linkedin, Github, EnvelopeFill } from "react-bootstrap-icons";

export const Footer = () => {
  return (
    <footer className="footer" id="contact">
      <Container>
        <Row className="align-items-center justify-content-center text-center">
          <Col md={10} lg={8}>
            <h2 className="footer-heading">Let's Build Something Together</h2>
            <p className="footer-subtext">
              Open to full-time roles, freelance projects, and interesting collaborations.
            </p>
            
            <div className="footer-contact-info">
              <a href="mailto:yasirudeshan3@gmail.com" className="contact-link">yasirudeshan3@gmail.com</a>
              <span className="contact-divider px-3 text-muted">|</span>
              <span className="contact-text">+94 77 214 1987</span>
              <span className="contact-divider px-3 text-muted">|</span>
              <span className="contact-text">Gampaha, Sri Lanka</span>
            </div>

            <div className="mt-4 mb-5">
              <a href="mailto:yasirudeshan3@gmail.com" className="cta-btn primary-btn d-inline-flex">
                Get In Touch
              </a>
            </div>

            <div className="social-icon">
              <a href="https://www.linkedin.com/in/yasiru-deshan-0b0593211/" target="_blank" rel="noopener noreferrer" className="d-inline-flex align-items-center justify-content-center">
                <Linkedin size={20} className="social-svg" />
              </a>
              <a href="https://github.com/Yasiru-Deshan" target="_blank" rel="noopener noreferrer" className="d-inline-flex align-items-center justify-content-center">
                <Github size={20} className="social-svg" />
              </a>
              <a href="mailto:yasirudeshan3@gmail.com" className="d-inline-flex align-items-center justify-content-center">
                <EnvelopeFill size={20} className="social-svg" />
              </a>
            </div>

            <p className="copyright mt-4">© 2026 Yasiru Deshan. All Rights Reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
